export default __webpack_public_path__ + "static/media/goshen103.f432c242.jpg";